var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Layout',[_c('PageHeader',{attrs:{"title":_vm.title,"items":_vm.items}}),(_vm.video && _vm.decMinutes != null)?_c('PlayerComponent',{attrs:{"video":_vm.video,"decMinutes":_vm.decMinutes}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }